module.exports = __webpack_public_path__ + "static/media/vase.e4c000f7.png";